// TODO remove this once authentication flows are in place
import {
    TokenData,
    tokenDataSchema,
} from "@/modules/authentication/schemas/token-data-schema";

export const decodeToken = (token: string): TokenData => {
    try {
        const parts = token.split(".");
        const json = JSON.parse(atob(parts[1]));
        return tokenDataSchema.parse(json);
    } catch (exception) {
        // atob fails if the token is not a JWT (e.g. a SAML token, Credentials token, etc.)
        return { role: "", username: "" };
    }
};
